import React from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer, Toast } from '@idexio/dev-idex-swap-uikit';
import { useToast } from 'state/hooks';
import { ReduxState } from 'state';

const ToastListener = () => {
  const toasts: Toast[] = useSelector((state: ReduxState) => state.toasts.data);
  const { remove } = useToast();

  const handleRemove = (id: string) => remove(id);

  return <ToastContainer toasts={toasts} onRemove={handleRemove} />;
};

export default ToastListener;
